module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-06.63c6d37e.jpg";